//All End points

import {
  columnMatching,
  initiateAiCall,
  shipmentNotificationListing,
} from "../api's/shipment";
import AlertThresholds from "../pages/Settings/AlertThresholds/AlertThresholds";
import EmailTranscriptModal from "../pages/Shipments/EmailTranscriptModal";

export const APIPaths = {
  // <!---All api enpoints for onboarding.js--->
  getAllCouriers: "/onboarding/couriers/",
  linkCourierAccount: "/auth/link-courier-to-company/",
  products: "/onboarding/products/",
  getAllSensors: "/onboarding/sensors/",
  linkSensorsAccount: "/onboarding/company-sensors/",
  users: "/auth/users/",
  teamUsers: "/auth/teams-users/",
  location: "/onboarding/locations/",
  notifications: "/shipment/alert/",
  product_type: "/onboarding/product-types/",
  create_account: "/onboarding/create-account/",

  //<!---All api enpoints for settings.js--->
  settingsProfile: "/auth/users/profile/",
  designations: "/auth/designations/",
  settingsLocation: "/onboarding/locations/v2/",
  transportProvider: "/onboarding/couriers/",
  companyTransportProvider: "/onboarding/couriers/",
  pendingUsers: "/auth/pending-users/",
  resendInvite: "/auth/users/resend-invite/",
  transportProviderDetail: "/auth/company-couriers-details/",
  teamsDDLForFeature: "/auth/feature-teams/",
  aiToggle: "/auth/company-ai-enable/",
  alertThreshold: "/shipment/alert-threshold/",

  //<!------All api enpoints for shipment.js----> [//added by nisha]
  addNewShipment: "/shipment/track/",
  addShipmentNotification: "/shipment/notifications/",
  settingsCourier: "/auth/company-couriers/",
  courierContacts: "/auth/couriers-contacts/",
  uploadBulkShipment: "/shipment/upload-shipments/",
  uploadFile: "/shipment/file-upload/",
  downloadBulkUploadTemplate: "/shipment/download-shipments_template/",
  callTranscript: "/shipment/alert-call-transcript/",
  emailTranscript: "/shipment/alert-email-transcript/",
  shipmentAlertStatus: "/shipment/shipment-alert-ai-status/",
  shipmentNotificationListing: "/shipment/notifications/",
  notificationRecipient: "/auth/teams-users/",
  bulkUpload: "/shipment/bulk-upload-files/v2/",
  bulkValidate: "/shipment/bulk-validate/v2/",
  bulkCreate: "/shipment/bulk-create/v2/",
  callTranscript:"/shipment/alert-call-transcript/",
  emailTranscript:"/shipment/alert-email-transcript/",
  shipmentAlertStatus:"/shipment/shipment-alert-ai-status/",
  shipmentNotificationListing:"/shipment/notifications/",
  notificationRecipient:"/auth/teams-users/",
  setExternalAlert:"/shipment/share-shipment-alerts/",

  //<!---All api enpoints for shipments.js--->
  authenticate_password: "/shipment/authenticate-shipment/",
  share_shipment: "/shipment/share-shipment/",
  shipments: "/shipment/",
  shipment_viewer: "/shipment/shipment-viewers/",
  custody_comments: "/shipment/chain-of-custody/comments/",
  getShipmentPoints: "/shipment/shipment-monitor/",
  shipment_alert: "/shipment/shipment-alerts/",
  resloved_alert: "/shipment/shipment-alert-resolved/",
  resloved_alert_comment: "/shipment/shipment-alert-complete/",
  shipment_archive: "/shipment/shipment-archive/",
  shipment_mark_as_delivered: "/shipment/shipment-delivered/",
  initiateAiCall: "/intervention/call/initiate/",
  noMessage: "/auth/ai-static-message/",
  get_link_code: "/shipment/link-codes/",

  //<!---All api enpoints for home.js--->
  shipment_locations: "/shipment/shipment-locations/",
  button_status: "/auth/button-status/",
  shipment_chart: "/auth/shipment-chart/",
  ontime_chart: "/auth/shipment-chart-ontime/",
  average_chart: "/auth/shipment-chart-transit/",
  right_Time_chart: "/auth/shipment-chart-right_first/",
  home_map_filter: "/shipment/shipment-locations/",
  home_news_flash: "/auth/newsflash/",
  home_target_metrics: "/auth/company-target/",

  //<!---All api enpoints for chatbot.js--->
  conversations: "/auth/conversation/all/",
  user_conversation: "/auth/conversation/",

  //<!--- All api enpoints for ROLES AND PERMISSIONS --->
  add_role: "/auth/roles/",
  role: "/auth/roles/",
  role_permissions: "/auth/roles/permissions/",
  get_menu: "/auth/user-menu-permissions/",

  //<!---All api enpoints for teams.js--->
  teams: "/auth/teams/",

  //<!---All api enpoints for airports--->
  airport_contacts: "/shipment/airports-contacts/",
  airport_data: "/shipment/airports/",
};
